<ng-template #contenu>
  <ng-content></ng-content>
</ng-template>
@if (label != null) {
  <div [ngClass]="{'is-error': errorsAreVisible()}" >
    <span class="form_label" [ngClass]="{'is-required': required}">{{label}}</span>
    <ng-template [ngTemplateOutlet]="contenu"></ng-template>
  </div>
} @else {
  <div [ngClass]="{'is-error': errorsAreVisible()}">
    <ng-template [ngTemplateOutlet]="contenu"></ng-template>
  </div>
}
@if (errorMessageIsVisible()) {
  <div class="form_error-message">
    {{getError()}}
  </div>
}

